import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {Button} from "react-bootstrap";
// eslint-disable-next-line no-restricted-imports
import {lighten, makeStyles} from "@material-ui/core/styles";
import {format} from "date-fns";
import AlertComponent from "../../../../../_metronic/_helpers/AlertComponent";
// eslint-disable-next-line no-restricted-imports
import {azAZ} from '@material-ui/core/locale';

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Paper,
    CircularProgress, TableSortLabel,
    createMuiTheme,
    ThemeProvider, InputLabel,
} from "@material-ui/core";
// eslint-disable-next-line no-restricted-imports
import TablePagination from "@material-ui/core/TablePagination";
import {DateTimePickerOutlined} from "../../../../components/DatePicker";
import {GMTDateConvert} from "../../../../../helpers";
import dayjs from "dayjs";

const theme = createMuiTheme(azAZ);

const headRows = [
    {
        id: "order",
        numeric: false,
        disablePadding: true,
        label: "Sıra",
    },
    {
        id: "transactionDateTime",
        numeric: false,
        disablePadding: true,
        label: "Tranzaksiya tarixi",
    },
    {
        id: "amount",
        numeric: false,
        disablePadding: true,
        label: "Məbləğ",
    },
    {
        id: "transactionType",
        numeric: false,
        disablePadding: true,
        label: "Tranzaksiya növü",
    },
    {
        id: "transactionStatus",
        numeric: false,
        disablePadding: true,
        label: "Tranzaksiya statusu",
    },
    {
        id: "depositAfterUpdate",
        numeric: false,
        disablePadding: true,
        label: "Aralıq ödənişdən sonrakı balans",
    },
];

function EnhancedTableHead({onRequestSort, sortField, orderBy}) {
    return (
        <TableHead>
            <TableRow>
                {headRows.map((row, index) => (
                    <TableCell sortDirection={sortField === row.id ? "asc" : false} key={index}
                               align={row.numeric ? "right" : "left"}>
                        <TableSortLabel active={sortField === row.id} direction={orderBy ? "desc" : "asc"}
                                        onClick={() => {
                                            onRequestSort(row.id)
                                        }}>
                            {row.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === "light"
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: "0 0 auto",
    },
    dense: {
        margin: theme.spacing(2),
    },
}));

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3),
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: "auto",
    },
    progressRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
}));

const badges = {
    0: {
        label: "Bilet ödənişi",
        variant: "success"
    },
    1: {
        label: "Bilet satışı",
        variant: "danger"
    },
    2: {
        label: "Ləğv",
        variant: "warning"
    },
}

const ticketStatuses = {
    "Win": {
        label: "Uduşlu",
        variant: "success"
    },
    "Lost": {
        label: "Uduşsuz",
        variant: "danger"
    },
    "Cancel": {
        label: "Ləğv",
        variant: "warning"
    }
}

export default function EnhancedTable({
                                          groups,
                                          count,
                                          isLoading,
                                          isError,
                                          errorMsg,
                                          deleteGroupsIds,
                                          setDeleteGroupsIds,
                                          sortField,
                                          setSortField,
                                          orderBy,
                                          setOrderBy,
                                          setSkip,
                                          setTake,
                                          take,
                                          skip,
                                          filterInputs,
                                          filterInputsUpdate,
                                          resetFilter,
                                          setFilterInputs
                                      }) {
    const classes = useStyles();

    function handleSelectAllClick(event) {
        if (event.target.checked) {
            const newSelecteds = groups.map((n) => n.id);
            setDeleteGroupsIds(newSelecteds);
            return;
        }
        setDeleteGroupsIds([]);
    }

    const isSelected = (name) => deleteGroupsIds.indexOf(name) !== -1;

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const handleRequestSort = (field) => {

        const isOrder = (field === sortField && !orderBy)

        setSortField(field);
        setOrderBy(isOrder);
        setTake(10);
        setRowsPerPage(10);
        setSkip(0);
        setPage(0);

    };

    function handleChangePage(event, newPage) {
        setPage(newPage);
        setSkip(take * newPage);
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setTake(+event.target.value);
        setPage(0);
        setSkip(0);
    }

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <div className="col-12 d-flex flex-wrap align-items-center py-4">
                    <div className="mr-2">
                        <InputLabel>Başlanğıc tarixi</InputLabel>
                        <DateTimePickerOutlined
                            value={filterInputs.transactionDateTimeStart ? dayjs(filterInputs.transactionDateTimeStart) : ""}
                            onChange={value => setFilterInputs(prevState => ({
                                ...prevState, transactionDateTimeStart: value ? GMTDateConvert(value) : ""
                            }))}
                        />
                    </div>
                    <div className="mr-2">
                        <InputLabel>Bitmə tarixi</InputLabel>
                        <DateTimePickerOutlined
                            value={filterInputs.transactionDateTimeEnd ? dayjs(filterInputs.transactionDateTimeEnd) : ""}

                            onChange={value => setFilterInputs(prevState => ({
                                ...prevState, transactionDateTimeEnd: value ? GMTDateConvert(value) : ""
                            }))}
                        />
                    </div>
                    <Button onClick={resetFilter} className="mx-2 my-2">Sıfırla</Button>
                </div>
                {isLoading && (
                    <div className={classes.progressRoot}>
                        <CircularProgress className={classes.progress}/>
                    </div>
                )}
                <div className={classes.tableWrapper}>
                    {groups.length ? (
                        <Table className={classes.table} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={deleteGroupsIds.length}
                                onSelectAllClick={handleSelectAllClick}
                                rowCount={groups.length}
                                onRequestSort={handleRequestSort}
                                sortField={sortField}
                                orderBy={orderBy}
                            />
                            <TableBody>
                                {groups.map((row, index) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={index}
                                            selected={isItemSelected}
                                        >
                                            <TableCell component="th" id={labelId} scope="row">
                                                {skip + index + 1}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.transactionDateTime && format(new Date(row.transactionDateTime), 'dd.MM.yyyy HH:mm')}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.amount}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.transactionType}
                                                {/*<Badge*/}
                                                {/*    variant={ticketStatuses[row.ticketStatus]?.variant ?? "warning"}>{ticketStatuses[row.ticketStatus]?.label ?? row.ticketStatus}</Badge>*/}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.transactionFailureString}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.depositAfterUpdate}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    ) : !groups.length && !isLoading && !isError ? (
                        <AlertComponent variant="info" message="Məlumat tapılmadı."/>
                    ) : (!isLoading && isError && (!isLoading && isError && (<AlertComponent
                        variant="danger"
                        message={errorMsg}
                    />)))}
                </div>
                {count > 10 && (
                    <ThemeProvider theme={theme}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{
                                "aria-label": "Previous Page",
                            }}
                            nextIconButtonProps={{
                                "aria-label": "Next Page",
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </ThemeProvider>
                )}
            </Paper>
        </div>
    );
}
